// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--jEiI1";
export var heroWrapper = "styles-module--heroWrapper--oa5WT";
export var text = "styles-module--text--Kr+q4";